module.exports = __webpack_public_path__ + "static/media/dp-icon-dark.cb787033.png";